import { Dayjs } from 'dayjs';
import { DataModel } from './data-model.js';

export class DataModelWithMetaData<T extends DataModel> {
  public constructor(
    public readonly lastUpdate: Dayjs,
    public readonly data: T,
  ) {}
}
